<script>
import Map from '@/components(new)/UI/Maps/SustainablePracticesMap/SustainablePracticesMap.vue'

export default {
  components: {
    Map
  },
  props: {
    dados: {
      type: Object
    }
  }
}
</script>

<template>
  <div v-loading="dados.loading" :style="dados.loading ? 'min-height: 100px;' : ''">
    <Map
      v-if="dados.spsList.length"
      :pratices="dados.spsList"
      :propertyShapeImovel="dados.propertyShapeImovel"
      :propertyShapePraticas="dados.propertyShapePraticas"
      :onlyView="true"
    />
    <div v-else-if="!dados.loading">
      <span>Não há georreferenciamento de práticas</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Georreferenciamento/Georreferenciamento.vue